import apiClient from "./config";

// ---------------------------
// RESULTS / QUIZ ANALYTICS
// ---------------------------

// POST /api/results/submit
export const submitQuizResult = async (payload) => {
  console.log("[API] submitQuizResult called");
  try {
    const response = await apiClient.post("/results/submit", payload);
    console.log("[API] submitQuizResult success");
    return response.data;
  } catch (error) {
    console.error("[API] submitQuizResult ERROR:", error?.message);
    throw new Error(
      error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to submit quiz result."
    );
  }
};

// GET /api/results/history/:reviewerId
export const getQuizHistory = async (reviewerId) => {
  console.log("[API] getQuizHistory called:", reviewerId);
  try {
    const response = await apiClient.get(`/results/history/${reviewerId}`);
    console.log("[API] getQuizHistory success");
    return response.data;
  } catch (error) {
    console.error("[API] getQuizHistory ERROR:", error?.message);
    throw new Error(
      error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to fetch quiz history."
    );
  }
};

// GET /api/results/all (For Analytics Dashboard)
export const getAllQuizResults = async () => {
  console.log("[API] getAllQuizResults called");
  try {
    const response = await apiClient.get("/results/all");
    console.log("[API] getAllQuizResults success");

    // Support either:
    // 1) { success: true, count, data: [...] }
    // 2) { data: [...] }
    // 3) direct array [...]
    const body = response.data;

    if (Array.isArray(body)) return body;
    if (Array.isArray(body?.data)) return body.data;
    if (Array.isArray(body?.results)) return body.results;

    return [];
  } catch (error) {
    console.error("[API] getAllQuizResults ERROR:", error?.message);
    // keep dashboard safe, don’t crash UI
    return [];
  }
};

// DELETE /api/results/:id
export const deleteQuizResult = async (resultId) => {
  console.log("[API] deleteQuizResult called with ID:", resultId);
  try {
    const response = await apiClient.delete(`/results/${resultId}`);
    console.log("[API] deleteQuizResult success");
    return response.data;
  } catch (error) {
    console.error("[API] deleteQuizResult ERROR:", error?.message);
    throw new Error(
      error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to delete quiz result."
    );
  }
};

// POST /api/results/batch-delete
export const batchDeleteQuizResults = async (resultIds) => {
  console.log("[API] batchDeleteQuizResults called with IDs:", resultIds);
  try {
    const response = await apiClient.post("/results/batch-delete", { ids: resultIds });
    console.log("[API] batchDeleteQuizResults success");
    return response.data;
  } catch (error) {
    console.error("[API] batchDeleteQuizResults ERROR:", error?.message);
    throw new Error(
      error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to delete selected quiz results."
    );
  }
};
